import { UniteTypeCurrency as PayoutCurrency } from '~/generated/payoutBackend/model';
import { UniteTypeCurrency as PayinCurrency } from '~/generated/payinBackend/model';

export type Currency = `${PayinCurrency}` | `${PayoutCurrency}`;

export const Currency = {
    ...PayinCurrency,
    ...PayoutCurrency,
} as const;
